import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import MyLogo from "@/assets/logo.svg?react";

interface LogoProps {
    className?: string;
    compact?: boolean;
}

export function Logo({ className, compact }: LogoProps) {
    return (
        <Link to="/" className={cn("inline-flex items-center gap-2 font-semibold text-lg cursor-pointer", className)}>
            <span className="inline-flex size-8 items-center justify-center bg-transparent">
                <MyLogo className="size-4 text-primary" />
            </span>
            {!compact && <span className="tracking-tight">Arrowise</span>}
        </Link>
    );
}
